import { useState } from 'react';
import { Toggle } from '@/components/ui/therapist/toggle';
import { useStoreActions, useStoreState } from '@/stores/store';
import { toggleTherapistCanSeeResults } from '@/api/services/user';

export function ToggleTherapistCanSeeResults({
  showErrorMessage,
}: {
  showErrorMessage: () => void;
}) {
  const therapistCanSeeResults = useStoreState(
    (state) => state.signedInUser?.user?.therapistCanSeeResults,
  );
  const localToggle = useStoreActions(
    (actions) => actions.toggleTherapistCanSeeResults,
  );
  const [checked, setChecked] = useState<boolean>(
    therapistCanSeeResults ?? false,
  );

  const switchToggleValue = async () => {
    const result = await toggleTherapistCanSeeResults({
      therapistCanSeeResults: !checked,
    });
    if (result) {
      localToggle(!checked);
      setChecked(!checked);
    } else {
      showErrorMessage();
    }
  };
  return <Toggle value={checked} onToggle={switchToggleValue} />;
}
